import clsx from 'clsx';
import cn from './style.module.sass';

type ClassicArrowPropsType = {
    onclick: () => void;
    isLeft?: boolean;
    isGray?: boolean;
    disabled?: boolean;
};

const ClassicArrow = ({ onclick, isLeft = false, isGray, disabled }: ClassicArrowPropsType) => {
    return (
        <button
            type="button"
            disabled={disabled}
            className={clsx(
                `${cn['classic-arrow']} ${isLeft ? cn['classic-arrow--left'] : ''} ${
                    isGray ? cn['classic-arrow--gray'] : ''
                } `
            )}
            onClick={onclick}
        >
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    /* eslint-disable-next-line max-len */
                    d="M8 1C8 0.447716 8.44771 0 9 0C9.55229 0 10 0.447715 10 1V14.4849L15.7778 8.70711C16.1683 8.31658 16.8014 8.31658 17.192 8.70711C17.5825 9.09763 17.5825 9.7308 17.192 10.1213L10.1209 17.1924C10.0659 17.2474 10.0061 17.2946 9.94281 17.3342C9.80529 17.7221 9.4351 18 9 18C8.59053 18 8.23854 17.7539 8.08388 17.4015C7.97287 17.353 7.86888 17.2832 7.77802 17.1924L0.706956 10.1213C0.316431 9.7308 0.316431 9.09763 0.706956 8.70711C1.09748 8.31658 1.73064 8.31658 2.12117 8.70711L8 14.5859V1Z"
                    fill="#7927E0"
                />
            </svg>
        </button>
    );
};

export default ClassicArrow;
